export default {
      id: "ic-misc-target-usage",
      viewBox: "0 0 26 26",
      url: "../dist/images/" + "sprite.svg#ic-misc-target-usage",
      toString: function () {
        return this.url;
      }
    }